<div class="tw-flex tw-w-full tw-items-center tw-justify-between">
    <div class="tw-flex">
        <span class="tw-text-xl tw-font-bold"
            >{{ 'ARTICLES.TITLE' | translate }}:</span
        >
        <span class="tw-ml-2 tw-text-xl tw-font-bold">{{
            data.article?.description
        }}</span>
        <span class="tw-ml-2 tw-ml-3 tw-text-xl"
            >{{ 'INCOMING-GOODS.DISCREPANCIES.AMOUNT' | translate }}:</span
        >
        <span class="tw-ml-2 tw-text-xl">{{ data.article?.quantity }}</span>
        @if (findAsnMetaData()?.storageLocation) {
            <span class="tw-ml-2 tw-ml-3 tw-text-xl">
                {{ 'ARTICLES.TABLE.STORAGE_LOCATION' | translate }}:
            </span>
        }
        @if (findAsnMetaData()?.storageLocation) {
            <span class="tw-ml-2 tw-text-xl">
                {{ findAsnMetaData()?.storageLocation }}
            </span>
        }
    </div>
    <button
        mat-icon-button
        (click)="closeDialog()">
        <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
    </button>
</div>
<mat-tab-group>
    @let asnMeta = findAsnMetaData();
    @let itemCode = getItemCode();
    @if (asnMeta?.advancedShippingNotice || itemCode) {
        <mat-tab label="CODES">
            <div class="tw-w-full tw-p-4">
                <div class="tw-flex tw-justify-between tw-items-center tw-mb-8">
                    <h1 class="tw-text-3xl tw-text-gray-800"></h1>
                    <mat-slide-toggle
                        [checked]="isQRCode"
                        (change)="toggleCodeType()">
                        {{ isQRCode ? 'QR Code' : 'Bar Code' }}
                    </mat-slide-toggle>
                </div>
                <!-- QR Codes -->
                @if (isQRCode) {
                    <div class="tw-flex tw-justify-center tw-gap-8">
                        <!-- only render ASN QR if a notice exists -->
                        @if (asnMeta?.advancedShippingNotice; as asn) {
                            <div
                                class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-flex-1">
                                <qr-code
                                    [value]="asn"
                                    [size]="getQRSize()"
                                    errorCorrectionLevel="L"
                                    [centerImageSize]="getQRSize() / 6"
                                    [margin]="4"></qr-code>
                                <p class="tw-text-lg tw-text-gray-600 tw-mt-4">
                                    ASN
                                </p>
                            </div>
                        }
                        <!-- Item QR: ASN item, falling back to Empfänger Article Number -->
                        @if (itemCode) {
                            @if (hasConsigneeShowItemQRCode()) {
                                <div
                                    class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-flex-1">
                                    <qr-code
                                        [value]="itemCode"
                                        [size]="getQRSize()"
                                        errorCorrectionLevel="L"
                                        [centerImageSize]="getQRSize() / 6"
                                        [margin]="4"></qr-code>
                                    <p
                                        class="tw-text-lg tw-text-gray-600 tw-mt-4">
                                        {{
                                            'OUTGOING-GOODS.COLUMN-FILTERS.customerArticleNumber'
                                                | translate
                                        }}
                                    </p>
                                </div>
                            } @else {
                                <app-feature-hint
                                    [featureType]="
                                        FeatureType.CONSIGNEE_SHOW_ITEM_QRCODE
                                    " />
                            }
                        }
                    </div>
                }
                <!-- Bar Codes -->
                @if (!isQRCode) {
                    <div class="tw-flex tw-flex-col tw-items-center tw-gap-8">
                        @if (asnMeta?.advancedShippingNotice; as asn) {
                            <div
                                class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full tw-max-w-xl">
                                <ngx-barcode6
                                    bc-format="CODE128"
                                    [bc-value]="asn"
                                    [bc-display-value]="false"
                                    [bc-width]="2"
                                    [bc-height]="100"
                                    [bc-font-size]="20"></ngx-barcode6>
                                <p class="tw-text-lg tw-text-gray-600 tw-mt-4">
                                    ASN
                                </p>
                            </div>
                        }
                        @if (itemCode) {
                            @if (hasConsigneeShowItemQRCode()) {
                                <div
                                    class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full tw-max-w-xl">
                                    <ngx-barcode6
                                        bc-format="CODE128"
                                        [bc-value]="itemCode"
                                        [bc-display-value]="false"
                                        [bc-width]="2"
                                        [bc-height]="100"
                                        [bc-font-size]="20"></ngx-barcode6>
                                    <p
                                        class="tw-text-lg tw-text-gray-600 tw-mt-4">
                                        {{
                                            'OUTGOING-GOODS.COLUMN-FILTERS.customerArticleNumber'
                                                | translate
                                        }}
                                    </p>
                                </div>
                            } @else {
                                <app-feature-hint
                                    [featureType]="
                                        FeatureType.CONSIGNEE_SHOW_ITEM_QRCODE
                                    " />
                            }
                        }
                    </div>
                }
            </div>
        </mat-tab>
    }

    <mat-tab label="{{ 'INCOMING-GOODS.DISCREPANCIES.TITLE' | translate }}">
        @if (hasConsigneeArticleDiscrepancies()) {
            <div
                class="tw-mt-3 tw-flex tw-w-full tw-flex-col tw-max-h-[400px] tw-overflow-auto">
                <div>
                    <form
                        id="form-discrepancies"
                        [formGroup]="discrepanciesForm"
                        (ngSubmit)="saveDiscrepancies()">
                        @for (
                            discrepanciesControl of discrepanciesFormArray?.controls;
                            track discrepanciesControl;
                            let i = $index
                        ) {
                            <div
                                class="tw-grid tw-grid-cols-[min-content_auto_min-content] tw-gap-x-3"
                                formArrayName="discrepancy">
                                <div class="tw-flex tw-h-full tw-items-center">
                                    @if (isDiscrepancyAutomatic(i)) {
                                        <mat-icon
                                            [matTooltip]="
                                                'INCOMING-GOODS.DISCREPANCIES.AUTOMATICALLY_ADDED'
                                                    | translate
                                            "
                                            fontSet="material-symbols-outlined"
                                            >robot_2</mat-icon
                                        >
                                    }
                                </div>
                                <div
                                    [formGroupName]="i"
                                    class="tw-grid tw-grid-cols-12 tw-gap-x-3 tw-overflow-auto">
                                    <div
                                        class="tw-col-span-3 tw-flex tw-h-full tw-items-center">
                                        <mat-form-field
                                            appearance="fill"
                                            class="!tw-pb-0">
                                            <mat-label>{{
                                                'INCOMING-GOODS.DISCREPANCIES.TYPE'
                                                    | translate
                                            }}</mat-label>
                                            <mat-select
                                                id="select-carrier"
                                                formControlName="reason"
                                                [placeholder]="
                                                    'INCOMING-GOODS.DISCREPANCIES.TYPE'
                                                        | translate
                                                ">
                                                @for (
                                                    discrepancyType of discrepancyChoices?.reasons;
                                                    track discrepancyType
                                                ) {
                                                    <mat-option
                                                        [value]="
                                                            discrepancyType
                                                        ">
                                                        {{
                                                            'INCOMING-GOODS.DISCREPANCIES.REASONS.' +
                                                                discrepancyType
                                                                | translate
                                                        }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div
                                        class="tw-col-span-2 tw-flex tw-h-full tw-items-center">
                                        <mat-form-field
                                            appearance="fill"
                                            class="!tw-pb-0">
                                            <mat-label>{{
                                                'INCOMING-GOODS.DISCREPANCIES.AMOUNT'
                                                    | translate
                                            }}</mat-label>
                                            <input
                                                matInput
                                                id="input-count-exchange-{{
                                                    i
                                                }}"
                                                type="number"
                                                min="0"
                                                oninput="this.value = Math.abs(this.value)"
                                                formControlName="number"
                                                [placeholder]="
                                                    'INCOMING-GOODS.DISCREPANCIES.AMOUNT'
                                                        | translate
                                                " />
                                        </mat-form-field>
                                    </div>
                                    <div
                                        class="tw-col-span-3 tw-flex tw-h-full tw-items-center">
                                        <mat-form-field
                                            appearance="fill"
                                            class="!tw-pb-0">
                                            <mat-label>{{
                                                'INCOMING-GOODS.DISCREPANCIES.UNIT'
                                                    | translate
                                            }}</mat-label>
                                            <mat-select
                                                formControlName="unit"
                                                [placeholder]="
                                                    'INCOMING-GOODS.DISCREPANCIES.UNIT'
                                                        | translate
                                                ">
                                                @for (
                                                    discrepancyUnit of discrepancyChoices?.units;
                                                    track discrepancyUnit
                                                ) {
                                                    <mat-option
                                                        [value]="
                                                            discrepancyUnit
                                                        ">
                                                        {{
                                                            'INCOMING-GOODS.DISCREPANCIES.UNITS.' +
                                                                discrepancyUnit
                                                                | translate
                                                        }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div
                                        class="tw-col-span-4 tw-flex tw-h-full tw-items-center">
                                        <mat-form-field
                                            appearance="fill"
                                            class="!tw-pb-0">
                                            <mat-label>Notiz</mat-label>
                                            <input
                                                matInput
                                                formControlName="note"
                                                placeholder="Notiz" />
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="tw-flex tw-h-full tw-items-center">
                                    <div
                                        [matTooltip]="
                                            'INCOMING-GOODS.DISCREPANCIES.BUTTONS.DELETE'
                                                | translate
                                        "
                                        (click)="removeDiscrepancy(i)">
                                        <mat-icon
                                            fontSet="material-symbols-outlined"
                                            >delete</mat-icon
                                        >
                                    </div>
                                </div>
                            </div>
                        }
                    </form>
                </div>
            </div>
            <div class="tw-flex tw-flex-wrap tw-items-center">
                <div class="flex-grow-1">
                    <div class="tw-mb-5 tw-flex tw-flex-wrap">
                        <button
                            mat-button
                            type="button"
                            [matTooltip]="
                                'INCOMING-GOODS.DISCREPANCIES.ADD-MORE'
                                    | translate
                            "
                            (click)="addDiscrepancy()">
                            <mat-icon fontSet="material-symbols-outlined"
                                >add</mat-icon
                            >
                            <span class="text-primary">{{
                                'INCOMING-GOODS.DISCREPANCIES.BUTTONS.ADD'
                                    | translate
                            }}</span>
                        </button>
                    </div>
                </div>
                <div class="align-content-end">
                    <button
                        form="form-discrepancies"
                        type="submit"
                        mat-flat-button
                        color="primary"
                        [disabled]="discrepanciesForm.invalid || formSaved">
                        @if (!formSaved) {
                            <span>{{ 'GLOBAL.BUTTON.SAVE' | translate }}</span>
                        }
                        @if (formSaved) {
                            <span>{{ 'GLOBAL.BUTTON.SAVED' | translate }}</span>
                        }
                    </button>
                </div>
            </div>
        } @else {
            <app-feature-hint
                [featureType]="FeatureType.CONSIGNEE_ARTICLE_DISCREPANCIES" />
        }
        @if (hasGeneralGUIFeatures()) {
            <app-load-carrier-form
                [deliveryNotesSignal]="deliveryNotesSignal"
                [articleId]="data.article._key"></app-load-carrier-form>
        }
    </mat-tab>
</mat-tab-group>
